<template>
  <v-row>
    <v-col cols="10">
      <v-file-input
        show-size
        counter
        v-model="fileUpload"
        accept=".csv"
        label="Seleccione el archivo a migrar:"
        clearable
      ></v-file-input>
    </v-col>
    <v-col cols="2">
      <v-btn
        block
        @click="convertToBase64()"
        text
        dark
        size="x-large"
        color="green"
      >
        <template v-slot:prepend>
          <v-icon>mdi-content-save</v-icon>
        </template>
        Guardar</v-btn
      >
    </v-col>
  </v-row>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Migracion-Activos",
  data() {
    return {
      progreso: false,
      fileUpload: [],
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Envia Archivo Base 64
    convertToBase64(event) {
      const file = this.fileUpload[0]; // Obtener el archivo seleccionado
      debugger;
      console.log(file);
      if (!file) return;

      const reader = new FileReader();
      reader.readAsDataURL(file); // Leer el archivo como Base64

      reader.onload = () => {
        var base64 = reader.result; // Guardar la cadena Base64
        this.getPostArvhivoAEP(base64); // Enviar la cadena Base64
      };

      reader.onerror = (error) => {
        console.error("Error al convertir a Base64:", error);
      };
    },
    // Envia Archivo Garantías
    async getPostArvhivoAEP(base64) {
      var userperfil = this.$store.getters.userperfil;
      this.progreso = true;
      var data = {
        ArchivoBase64: base64,
        Empresa: null,
        User: userperfil.userInfo.Usuario_ID,
      };

      this.axios
        .post("/ActivosO/MigracionActivos/CR2", data)
        .then((response) => {
          this.fileUpload = [];
          this.$swal({
            icon: "success",
            title: "Relación Guardada",
            html: "La información se ha guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
  },
  mounted() {},
};
</script>
